<template>
	<div>
		<Header />

		<div class="login">
			<h1>Log ind</h1>
			<form @submit.prevent="login">
				<div class="form-group">
					<div class="input-group" ref="emailgroup">
						<label for="email">
							E-mail
						</label>
						<input v-model="email" type="email" name="email" value>
					</div>

					<div class="input-group" ref="passwordgroup">
						<label for="password">
							Kodeord
						</label>
						<input v-model="password" type="password" name="password" value>
					</div>

					<div class="validation-group" ref="validationgroup"></div>
				</div>
				<div class="buttons-group center">
					<button type="submit" name="button">
						Log ind
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/common/Header.vue";
	import { types } from "@/app/types/types";

	export default {
		data()
		{
			return {
				email: "",
				password: "",
				loginresult: false
			}
		},
		components:
		{
			Header
		},
		methods:
		{
			async login()
			{
				this.setAppAsBusy();

				try
				{
					var result = await this.$store.dispatch(types.ACTION_AUTHENTICATE_CREDENTIALS,
						{
							email: this.email,
							password: this.password
						});

					if (result.status == 400)
					{
						log("Unauthorized: " + result.data.message);
						this.setAppAsIdle();
						this.$refs.validationgroup.setAttribute("data-validation", "Forkert e-mail eller kodeord.")
					}
					else if (result.status == 500)
					{
						log("Api error: " + result.message);
						this.setAppAsIdle();
						this.$refs.validationgroup.setAttribute("data-validation", "Der opstod en fejl. Opdater siden og prøv igen.")
					}
					else if (result.status == 200)
					{
						this.setAppAsIdle();
						this.$router.push({ name: "Start" })
					}
				}
				catch (e)
				{
					log("Error: " + e.message);
					this.setAppAsIdle();
					this.$refs.validationgroup.setAttribute("data-validation", "Der opstod en fejl. Opdater siden og prøv igen.")
				}
			}
		}
	}
</script>